/**
 * Get content session from brightspot
 *
 */
import { gql } from '@apollo/client'
import { getIsLowBandwidth } from '../../hooks/useIsLowBandwidth'

export const virtualBoothGQLQuery = (path) => {
  const imageSize = getIsLowBandwidth() ? 250 : 500
  return gql(`{
    ExhibitorPage(id: "${path}") {
      contactEmail
      description
      name
      graphics{
        custom(height: 317, width: 590, crop:true) {
          image {
            src
            }
          }
      }
      productBrochureTitle1
      productBrochureTitle2
      productBrochureTitle3
      productBrochureTitle4
      productBrochureTitle5
      url
      contentId
      companyContactUsUrl {
        url
      }
      companySupportUrl {
        url
      }
      welcomeVideo {
        videoProvider {
          ... on YoutubeVideoProvider {
            providerType
            videoDuration
            videoId
          }
          ... on RootsTechBrightcoveVideoProvider {
            accountId
            providerType
            videoId
          }
        }
      }
      productBrochurePdf1 {
        href
        title
        contentId
      }
      productBrochurePdf2 {
        href
        title
        contentId
      }
      productBrochurePdf3 {
        href
        title
        contentId
      }
      productBrochurePdf4 {
        href
        title
        contentId
      }
      productBrochurePdf5 {
        href
        title
        contentId
      }

      logo {
        custom(height: ${imageSize}, width: ${imageSize}) {
          image {
            src
          }
        }
      }
      linkedin {
        url
      }
      instagram {
        url
      }
      faqsUrl {
        url
      }
      facebook {
        url
      }
      twitter {
        url
      }
      youtube{
        url
      }
      websiteUrl {
        url
      }
      exhibitorVideos {
        videoProvider {
          ... on YoutubeVideoProvider {
            providerType
            videoDuration
          }
        }
      }
      promotions{
        objectTypeId
        title
        description
        url
        type
        contentUUID
        image {
          custom(height: ${imageSize}, width: ${imageSize}) {
            image {
              src
            }
          }
        }
      }
      additionalExperiences{
        objectTypeId
        title
        description
        url
        type
        contentUUID
        image {
          custom(height: ${imageSize}, width: ${imageSize}) {
            image {
              src
            }
          }
        }
      }

      content {
        ... on ListModule {
          _viewTemplate
          ctaTarget
          ctaUrl
          ctaText
          description
          title
          items {
            contentUUID
            objectTypeId
            title
            description
            url
            type
            image {
              custom(height: ${imageSize}, width: ${imageSize}) {
                image {
                  src
                }
              }
            }
            date {
              timestamp
            }
            parentLocale
            locale
          }
        }
      }
    }
}
  `)
}

export const dummy = () => {}
